import axios from "../../axios";
import * as actionTypes from "./actionTypes";

export const userClearMessage = () => {
  return {
    type: actionTypes.USER_CLEAR_MESSAGE,
  };
};

export const enrollCourseStart = () => {
  return {
    type: actionTypes.ENROLL_COURSE_START,
  };
};

export const enrollCourseSuccess = (success) => {
  return {
    type: actionTypes.ENROLL_COURSE_SUCCESS,
    success: success,
  };
};

export const enrollCourseFail = (error) => {
  return {
    type: actionTypes.ENROLL_COURSE_FAIL,
    error: error,
  };
};

export const EnrollCourse = (courseId, isMe) => {
  return (dispatch) => {
    dispatch(enrollCourseStart());
    const user = JSON.parse(localStorage.getItem("user"));
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user.accessToken}`,
    };
    const data = {
      maKhoaHoc: courseId,
      taiKhoan: user.taiKhoan,
    };
    let url = "/QuanLyKhoaHoc/DangKyKhoaHoc";
    if (isMe) {
      url = "/QuanLyKhoaHoc/HuyGhiDanh";
    }
    axios({ method: "post", url, headers, data })
      .then((response) => {
        dispatch(enrollCourseSuccess(response.data));
        dispatch(fetchUserListInThisCourse(courseId));
      })
      .catch((error) => {
        dispatch(enrollCourseFail(error.response.data));
      });
  };
};

export const fetchUserListInThisCourseStart = () => {
  return {
    type: actionTypes.FETCH_USER_LIST_IN_THIS_COURSE_START,
  };
};

export const fetchUserListInThisCourseSuccess = (userList) => {
  return {
    type: actionTypes.FETCH_USER_LIST_IN_THIS_COURSE_SUCCESS,
    userList: userList,
  };
};

export const fetchUserListInThisCourseFail = (error) => {
  return {
    type: actionTypes.FETCH_USER_LIST_IN_THIS_COURSE_FAIL,
    error: error,
  };
};

export const fetchUserListInThisCourse = (courseId) => {
  return (dispatch) => {
    dispatch(fetchUserListInThisCourseStart());
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.accessToken) {
      let config = {
        method: "get",
        url: `/QuanLyKhoaHoc/LayThongTinHocVienKhoaHoc?maKhoaHoc=${courseId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.accessToken}`,
        },
      };

      // console.log("user List in course:", config )
      axios(config)
        .then((response) => {
          // console.log(response.data);
          dispatch(fetchUserListInThisCourseSuccess(response.data));
        })
        .catch((error) => {
          // console.log(error);
          dispatch(fetchUserListInThisCourseFail(error.response.data));
        });
    }
  };
};


//My Changes
export const enrollProductStart = () => {
  return {
    type: actionTypes.ENROLL_PRODUCT_START,
  };
};

export const enrollProductSuccess = (success) => {
  return {
    type: actionTypes.ENROLL_PRODUCT_SUCCESS,
    success: success,
  };
};

export const enrollProductFail = (error) => {
  return {
    type: actionTypes.ENROLL_PRODUCT_FAIL,
    error: error,
  };
};

export const EnrollProduct = (courseId, isMe) => {
  return (dispatch) => {
    dispatch(enrollProductStart());
    const user = JSON.parse(localStorage.getItem("user"));
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user.accessToken}`,
    };
    const data = {
      maKhoaHoc: courseId,
      taiKhoan: user.taiKhoan,
    };
    let url = "/QuanLyKhoaHoc/DangKyKhoaHoc";
    if (isMe) {
      url = "/QuanLyKhoaHoc/HuyGhiDanh";
    }

    // url = "http://localhost:3000/enrolled_prod_user"
    axios({ method: "post", url, headers, data })
      .then((response) => {
        dispatch(enrollProductSuccess(response.data));
        dispatch(fetchUserListInThisProduct(courseId));
      })
      .catch((error) => {
        dispatch(enrollProductFail(error.response.data));
      });
  };
};

export const fetchUserListInThisProductStart = () => {
  return {
    type: actionTypes.FETCH_USER_LIST_IN_THIS_PRODUCT_START,
  };
};

export const fetchUserListInThisProductSuccess = (userList) => {
  return {
    type: actionTypes.FETCH_USER_LIST_IN_THIS_PRODUCT_SUCCESS,
    userList: userList,
  };
};

export const fetchUserListInThisProductFail = (error) => {
  return {
    type: actionTypes.FETCH_USER_LIST_IN_THIS_PRODUCT_FAIL,
    error: error,
  };
};

export const fetchUserListInThisProduct = (courseId) => {
  return (dispatch) => {
    dispatch(fetchUserListInThisProductStart());
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.accessToken) {
      let config = {
        method: "get",
        url: `/QuanLyKhoaHoc/LayThongTinHocVienKhoaHoc?maKhoaHoc=${courseId}`,
        // url : "http://localhost:3000/enrolled_prod_user",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.accessToken}`,
        },
      };

      // console.log("user List in course:", config )
      
      axios(config)
        .then((response) => {
          console.log("fetch product in list",response.data);
          dispatch(fetchUserListInThisProductSuccess(response.data));
        })
        .catch((error) => {
          console.log(error);
          dispatch(fetchUserListInThisProductFail(error.response.data));
        });
    }
  };
};
